import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import "./App.css";
import "./modern-cart-style.css"

// Uncommented below for v1 store display
import { PRODUCTS } from "../data/products";



// const PRODUCTS = [
//   { id: 1, name: "US-Japan Summer Exchange 2025 - Training", price_cents: 438000, price_id: "price_1REgzkL3ULrcHZjSOupM3FO9",
//     image_url: "./product_logo.JPG",
//     description: "July15-28 Japan Exchange - Kids with training"
//    },
//   { id: 2, name: "US-Japan Summer Exchange 2025 - General Accompany", price_cents: 328000, price_id: "price_1REh3ZL3ULrcHZjSfcZKYlJm",
//     image_url: "./product_logo.JPG",
//     description: "July15-28 Japan Exchange - General Accompany"
//    },
//   { id: 3, name: "US-Japan Summer Exchange 2025 - Senior/Baby Accompany", price_cents: 278000, price_id: "price_1REh3pL3ULrcHZjSI10y775S",
//     image_url: "./product_logo.JPG",
//     description: "July15-28 Japan Exchange - Senior/Baby Accompany"
//    },

//   // // Below is ConnectedSports test mode products
//   // { id: 1, name: "US-Japan Summer Exchange 2025 - Training", price_cents: 438000, price_id: "price_1NchhrGygx7EG5d7ue3Tfszj",
//   //   image_url: "./product_logo.JPG",
//   //   description: "July15-28 Japan Exchange - Kids with training"
//   //  },
// ];

const CART_KEY = "cart";
const CART_EXPIRY_KEY = "cart_expiry";
const EXPIRY_HOURS = 24;

function saveCartWithExpiry(cart) {
  const expiryTimestamp = Date.now() + EXPIRY_HOURS * 60 * 60 * 1000;
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  localStorage.setItem(CART_EXPIRY_KEY, expiryTimestamp.toString());
}

function loadCartWithExpiry() {
  const expiry = localStorage.getItem(CART_EXPIRY_KEY);
  if (expiry && Date.now() > Number(expiry)) {
    localStorage.removeItem(CART_KEY);
    localStorage.removeItem(CART_EXPIRY_KEY);
    return [];
  }
  const saved = localStorage.getItem(CART_KEY);
  return saved ? JSON.parse(saved) : [];
}

// === Main Component ===
function App() {
  const [cart, setCart] = useState(() => loadCartWithExpiry());

  const addToCart = (product) => {
    setCart((prev) => {
      const exists = prev.find((item) => item.price_id === product.price_id);
      const newCart = exists
        ? prev.map((item) =>
            item.price_id === product.price_id
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        : [...prev, { ...product, quantity: 1 }];
      saveCartWithExpiry(newCart);
      return newCart;
    });
  };

  const increment = (price_id) => {
    setCart((prev) => {
      const updated = prev.map((item) =>
        item.price_id === price_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      saveCartWithExpiry(updated);
      return updated;
    });
  };

  const decrement = (price_id) => {
    setCart((prev) => {
      const updated = prev
        .map((item) =>
          item.price_id === price_id
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
        .filter((item) => item.quantity > 0);
      saveCartWithExpiry(updated);
      return updated;
    });
  };

  const remove = (price_id) => {
    setCart((prev) => {
      const updated = prev.filter((item) => item.price_id !== price_id);
      saveCartWithExpiry(updated);
      return updated;
    });
  };

  const total = cart.reduce((acc, item) => acc + item.price_cents * item.quantity, 0);

  const checkout = async () => {
    const items = cart.map(({ price_id, quantity }) => ({ price_id, quantity }));
    const res = await fetch(process.env.REACT_APP_API_URL + "/create-checkout-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_CHECKOUT_API_KEY,
      },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    window.location.href = data.url;
  };

  const checkoutACH = async () => {
    const items = cart.map(({ price_id, quantity }) => ({ price_id, quantity }));
    const res = await fetch(process.env.REACT_APP_API_URL + "/create-ach-checkout-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_CHECKOUT_API_KEY,
      },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    window.location.href = data.url;
  };

  return (
    <div className="container">
      <h1>US-Japan Summer Exchange 2025</h1>
      <div className="products">
        {PRODUCTS.map((product) => (
          <div className="product" key={product.id}>
            <img src={product.image_url} alt={product.name} className="product-image" />
            <h3>{product.name}</h3>
            <p className="description">{product.date}<br/>{product.description}</p>
            <p className="price">${(product.price_cents / 100).toFixed(2)}</p>
            {cart.find((item) => item.price_id === product.price_id) ? (
              <div className="add-remove-group">
                <button onClick={() => decrement(product.price_id)}>-</button>
                <span>{cart.find((item) => item.price_id === product.price_id)?.quantity}</span>
                <button onClick={() => increment(product.price_id)}>+</button>
              </div>
            ) : (
              <button onClick={() => addToCart(product)}>Add to Cart</button>
            )}
          </div>
        ))}
      </div>

      <div className="cart">
        <h2>Cart</h2>
        {cart.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <>
            {cart.map((item) => (
              <div key={item.price_id} className="cart-item">
                <div className="cart-item-left">
                  <span className="cart-item-name">{item.name}</span>
                </div>
                <div className="cart-item-right">
                  <div className="quantity-controls">
                    <button onClick={() => decrement(item.price_id)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => increment(item.price_id)}>+</button>
                  </div>
                  <span className="cart-price">${((item.price_cents * item.quantity) / 100).toFixed(2)}</span>
                  <button className="remove-btn" onClick={() => remove(item.price_id)}>x</button>
                </div>
              </div>
            ))}
            <hr />
            <p><strong>Total: ${(total / 100).toFixed(2)}</strong></p>
            <div className="checkout-buttons">
              <button className="checkout-btn" onClick={checkout}>Pay with Card/Alipay/WeChat (4% processing fee)</button>
              <button className="checkout-btn ach" onClick={checkoutACH}>Pay with ACH (no extra cost)</button>
            </div>
          </>
        )}
      </div>
      <footer style={{ textAlign: "center", marginTop: "50px", fontSize: "14px", color: "#777", lineHeight: "1.6" }}>
        <p>
          By proceeding, you agree to our{" "}
          <Link
            to="/privacy"
            style={{
              color: "#f4c10f",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Privacy Policy
          </Link>.
        </p>
        <p style={{ marginTop: "10px" }}>
          Copyright © 2023 - Connected Sports Inc. All Rights Reserved.
        </p>
      </footer>



    </div>
  );
}

export default App;

